import { useEffect } from "react";
import { useNavigate } from "react-router";
import useGetPageInfo from "../../common/hooks/useGetPageInfo";

const UserManagementPage = () => {
  const pageInfo = useGetPageInfo();
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/UM/Yeksa");
  }, []);
};

export default UserManagementPage;
